import {FC} from 'react'
import {Link} from 'react-router-dom'
import {AppRoute, SidebarTranslations as st} from 'Services/I18n/Constants'

import {FormattedMessage} from 'react-intl'
import {getRoute} from 'Services/I18n/Utils'

export const EmployerDashboardLinks: FC = () => {
  return (
    <>
      <h2>
        <FormattedMessage id={st.dashboard} />
      </h2>
      <ul>
        <li>
          <Link to={getRoute(AppRoute.EmployerDashboard)}>
            <FormattedMessage id={st.dashboard} />
          </Link>
        </li>
        <li>
          <Link to={getRoute(AppRoute.EmployerContactRequests)}>
            <FormattedMessage id={st.contactRequests} />
          </Link>
        </li>
        <li>
          <Link to={getRoute(AppRoute.EmployerInterviewInvitations)}>
            <FormattedMessage id={st.videoInterviews} />
          </Link>
        </li>
        <li>
          <Link to={getRoute(AppRoute.EmployerOffers)}>
            <FormattedMessage id={st.offers} />
          </Link>
        </li>
        <li>
          <Link to={getRoute(AppRoute.EmployerPlacements)}>
            <FormattedMessage id={st.placements} />
          </Link>
        </li>
      </ul>
    </>
  )
}
